import UniversalModal from './UniversalModal';

/**
 * ModalContainer - Legacy wrapper around UniversalModal
 * Maintained for backwards compatibility with existing code
 * Does not use portal rendering, supports footer and subtitle
 *
 * @deprecated Use UniversalModal directly for new code
 */
export default function ModalContainer({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer,
  maxWidth = 'max-w-2xl',
  isProcessing = false,
  className = ''
}) {
  return (
    <UniversalModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      footer={footer}
      maxWidth={maxWidth}
      isProcessing={isProcessing}
      className={className}
      usePortal={false}
      zIndex={50}
    >
      {children}
    </UniversalModal>
  );
}
